import React from 'react';

import AddViewEditDashboardNew from './Dashboard/AddViewEditDashboard';
import HomeDashboardContainer from './Dashboard/HomeDashboardContainer';
import WidgetContainerNew from './Widget/WidgetContainer';

const DashboardContainer = () => {
  const action = window.location.pathname.split('/')[3];
  const type = window.location.pathname.split('/')[2];

  return (
    <>
      {action === undefined ? (
        <HomeDashboardContainer />
      ) : type !== 'widget' ? (
        <AddViewEditDashboardNew />
      ) : (
        <WidgetContainerNew />
      )}
    </>
  );
};

export default DashboardContainer;
